import { LAUNCH_HOP_BOOST, POWER_UPS, SIREN_SPEED_BOOST, powerUpSeconds, type PowerUpId } from '@accra/shared';
import type { EventBus } from '../../core/events';
import type { RunState } from '../../game/RunState';

export function isActive(state: RunState, id: PowerUpId): boolean {
  return state.powers[id] > 0;
}

export function startPowerUp(state: RunState, id: PowerUpId, events: EventBus): void {
  const seconds = powerUpSeconds(id, state.upgrades[id]);
  state.powers[id] = seconds;
  state.stats.powerUps += 1;
  const name = POWER_UPS.find((p) => p.id === id)?.name ?? id;
  events.emit('powerUp:started', { id, name, seconds });
}

/** Counts power-ups down; also applies the speed and hop boosts to the trotro. */
export function updatePowerUps(state: RunState, dt: number, events: EventBus): void {
  for (const id of Object.keys(state.powers) as PowerUpId[]) {
    if (state.powers[id] <= 0) continue;
    state.powers[id] = Math.max(0, state.powers[id] - dt);
    if (state.powers[id] === 0) events.emit('powerUp:ended', { id });
  }
  state.bus.speedBoost = isActive(state, 'siren') ? SIREN_SPEED_BOOST : 1;
  state.bus.hopBoost = isActive(state, 'launch') ? LAUNCH_HOP_BOOST : 1;
}

/** Shield: takes one crash. Returns true if it did (and is used up). */
export function shieldSaves(state: RunState, cause: string, events: EventBus): boolean {
  if (!isActive(state, 'shield')) return false;
  state.powers.shield = 0;
  state.bus.invulnerable = 1.2;
  events.emit('powerUp:saved', { id: 'shield', cause });
  events.emit('powerUp:ended', { id: 'shield' });
  return true;
}
